function toDate(value: string | Date): Date {
    return typeof value === "string" ? new Date(value) : value;
}

/** en-US example: "8/3/2026". */
export function formatDate(value: string | Date): string {
    return toDate(value).toLocaleDateString();
}

/** en-US example: "8/3/26". */
export function formatDateShort(value: string | Date): string {
    return toDate(value).toLocaleDateString(undefined, { dateStyle: "short" });
}

/** en-US example: "Aug 3". */
export function formatMonthDay(value: string | Date): string {
    return toDate(value).toLocaleDateString(undefined, { month: "short", day: "numeric" });
}

/** en-US example: "8/3/2026, 2:07:03 PM". */
export function formatDateTime(value: string | Date): string {
    return toDate(value).toLocaleString();
}

/** en-US example: "8/3/26, 2:07 PM". */
export function formatDateTimeShort(value: string | Date): string {
    return toDate(value).toLocaleString(undefined, { dateStyle: "short", timeStyle: "short" });
}

/** en-US example: "8/3/26, 2:07:03 PM". */
export function formatDateTimeMedium(value: string | Date): string {
    return toDate(value).toLocaleString(undefined, { dateStyle: "short", timeStyle: "medium" });
}

export function calculateWeekStart(date: string) {
    const initialDate = new Date(date);
    const dayOfWeek = initialDate.getDay();
    const firstDayOfWeek = 1;
    const daysToSubtract = (dayOfWeek - firstDayOfWeek + 7) % 7;

    const startOfWeek = new Date(date);
    startOfWeek.setDate(startOfWeek.getDate() - daysToSubtract);

    startOfWeek.setHours(0, 0, 0, 0);
    return startOfWeek.toISOString().split(".")[0] + "Z";
}
